function toggleFaq(ele_id) {
  //remove active class
  document.querySelectorAll('.faq_cat').forEach(function(el) {
   el.classList.remove("active");
  });
  //add active class on clicked element
  document.getElementById(ele_id).classList.add("active");
  
  //hide all accordion
  document.querySelectorAll('.accordion').forEach(function(el) {
   el.style.display = 'none';
  });

  //show active accordion
  document.querySelectorAll('.accordion.'+ele_id+'').forEach(function(el) {
   el.style.display = 'block';
  });
}